import React from 'react';
import { Item } from 'react-photoswipe-gallery';
import { useInView } from 'react-intersection-observer';

const ImageBlock = ({ block, colSize, STRAPI_URL }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const image = block?.Image;
  if (!image) return null;

  // Fallback-safe URLs
  const fullUrl = `${STRAPI_URL}${image.formats?.large?.url || image.formats?.medium?.url || image.url}`;
  const thumbUrl = `${STRAPI_URL}${image.formats?.large?.url || image.formats?.medium?.url || image.url}`;
  const altText = image.alternativeText || 'Portfolio Image';

  const width = image.formats?.large?.width || 1200;
  const height = image.formats?.large?.height || 800;
  const ratioClass = block.Ratio || 'equal-md-2-1';

  return (
    <div className={`col-12 col-lg-${colSize}`}>
      <Item
        original={fullUrl}
        thumbnail={thumbUrl}
        width={width}
        height={height}
        caption={altText}
      >
        {({ ref: itemRef, open }) => (
          <figure
            ref={(node) => {
              ref(node);
              itemRef(node);
            }}
            className={`media media-image equal-1-1 ${ratioClass}`}
            onClick={open}
            onContextMenu={(e) => e.preventDefault()}
            style={{
              cursor: 'zoom-in',
              position: 'relative',
              margin: 0,
              width: '100%',
              overflow: 'hidden',
            }}
          >
            <span
              role="img"
              aria-label={altText}
              draggable={false}
              style={{
                backgroundImage: inView ? `url('${thumbUrl}')` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100%',
                height: '100%',
                display: 'block',
                filter: inView ? 'blur(0)' : 'blur(10px)',
              }}
            />
          </figure>
        )}
      </Item>
    </div>
  );
};

export default ImageBlock;
